<template>
    <div>
        <div ref="moreContent" class="hidden">
            <slot></slot>
        </div>
        <slot ref="moreLink" name="more-link" v-bind:more-link-events="moreLinkEvents" v-if="!showingMore"></slot>
    </div>
</template>

<script>
import Velocity from 'velocity-animate';

export default {
    name: 'MoreContent',
    data() {
        let self = this;
        return {
            showingMore: false,
            moreLinkEvents: {
                click (e) {
                    e.preventDefault();
                    self.showingMore = true;
                    Velocity(self.$refs.moreContent, 'slideDown', { duration: 250, easing: "easeInOutQuad" })
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/js/components/MoreContent.vue